import { extend } from 'flarum/extend';
import DiscussionListItem from 'flarum/components/DiscussionListItem';

export default function() {

  extend(DiscussionListItem.prototype, 'infoItems', function(items) {
    const terminalPost = items.items.terminalPost;
    if (terminalPost) {
      const firstPost = terminalPost.content.attrs.discussion.data.relationships.firstPost;
      const firstPostId = firstPost ? firstPost.data.id : null;
      if (firstPostId) {
        let excerpt = app.store.data.posts[firstPostId].data.attributes.contentHtml;

        // Strip for HTML tags and only show 175 characters
        excerpt = excerpt.replace(/(<([^>]+)>)/gi, "");
        excerpt = excerpt.slice(0, 175);
        items.add('excerpt', <p>{ excerpt }</p>, -100);

      }
    }
  });
}
